<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="onTabClick">
      <el-tab-pane :label="$t('gongshimingxi')" name="detail">
        <yi_curd_table :name="$options.name" ref="yt" getUrl="/web/report/page/work_hour_report" getKey="rows" :columns="detailColumns" :fixContainerHeight="fixContainerHeight" :isExpand="true">
          <template #conditions>
            <el-form size="mini" :inline="true" :model="query" class="demo-form-inline">
              <el-form-item :label="$t('jihuadanhao')">
                <el-input v-model="query.no" />
              </el-form-item>
              <el-form-item :label="$t('shebeimingcheng')">
                <yi_data_select :type="'equipment'" :ids.sync="query.equipmentId" @change="handleEquipmentChange" />
              </el-form-item>
              <el-form-item :label="$t('banci')">
                <el-select v-model="query.shiftId" filterable :clearable="true" :disabled="shiftDisabled">
                  <el-option v-for="(item, index) in shiftOptions" :key="index" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('riqi')">
                <yi_time_input :format="'yyyy-MM-dd'" type="date" :time.sync="query.summaryDate" :clearable="false" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" plain @click="onSearch">{{ $t('sousuo') }}</el-button>
                <el-button @click="clearConditions">{{ $t('chongzhi') }}</el-button>
                <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
              </el-form-item>
            </el-form>
          </template>
          <template #gongshileixing="scope">
            <span>{{ formatWorkHourType(scope.row.workHourType) }}</span>
          </template>
          <template #设备工时="scope">
            <span>{{ formatHours(scope.row.runDuration) }}</span>
          </template>
          <template #riqi="scope">
            <span>{{ formatDate(scope.row.summaryDate) }}</span>
          </template>
          <template #buttonsR>
            <el-button size="mini" :loading="exportLoading" icon="el-icon-download" :title="$t('daochu')" @click="exportDetailExcel"></el-button>
            <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="$refs.yt.showColumnsDialog()"></el-button>
          </template>
        </yi_curd_table>
      </el-tab-pane>
      <el-tab-pane :label="$t('gongshihuizong_shebei_moju')" name="summary">
        <el-table :data="summaryRows" size="medium" stripe border highlight-current-row :row-style="{ height: 42 + 'px' }" :cell-style="{ padding: 0 + 'px' }" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }" style="width: 100%" :height="summaryTableHeight">
          <el-table-column prop="date" :label="$t('riqi')" width="140" />
          <el-table-column prop="equipmentName" :label="$t('shebeimingcheng')" width="160" />
          <el-table-column prop="mouldNo" :label="$t('mujubianhao')" width="160" />
          <el-table-column prop="peopleWorkHours" :label="$t('renyuangongshi')" width="120">
            <template slot-scope="scope">{{ scope.row.peopleWorkHours }}</template>
          </el-table-column>
          <el-table-column prop="deviceWorkHours" :label="$t('shebeigongshi')" width="120">
            <template slot-scope="scope">{{ scope.row.deviceWorkHours }}</template>
          </el-table-column>
          <el-table-column prop="workHourTypeText" :label="$t('gongshileixing')" min-width="160" />
          <el-table-column prop="employeeNames" :label="$t('renyuanmingdan')" min-width="220" />
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import XLSX from 'xlsx';
export default {
  name: 'web_report_work_hour_report_list',
  data() {
    return {
      activeName: 'detail',
      shiftOptions: [],
      shiftDisabled: true,
      detailColumns: [
        { label: this.$t('jihuadanhao'), prop: 'no', width: 160 },
        { label: this.$t('shebeimingcheng'), prop: 'equipmentName', width: 140 },
        { label: this.$t('mujubianhao'), prop: 'mouldNo', width: 140 },
        { label: this.$t('gonghao'), prop: 'jobNo', width: 120 },
        { label: this.$t('xingming'), prop: 'employeeName', width: 120 },
        { label: this.$t('baogongbanci'), prop: 'shiftName', width: 100 },
        { label: 'riqi', prop: 'summaryDate', type: 'slot', width: 130 },
        { label: this.$t('renyuangongshi'), prop: 'workHours', width: 120 },
        { label: this.$t('shebeigongshi'), prop: 'runDuration', type: 'slot', width: 120 },
        { label: 'gongshileixing', prop: 'workHourType', type: 'slot', minWidth: 140 }
      ],
      // 缓存明细数据用于汇总
      detailListCache: [],
      // 本地查询模型，避免与内部 conditions 冲突
      query: {
        no: '',
        equipmentId: '',
        shiftId: '',
        summaryDate: null
      },
      // 动态容器高度（用于自适应表格高度）
      fixContainerHeight: 0,
      summaryTableHeight: null,
      // 本地分页缓存（按条件构建key）
      clientPageCacheKey: '',
      clientPageFullRows: [],
      exportLoading: false
    };
  },
  created() {
    // 初始化默认查询参数（可按需设定）
    setTimeout(() => {
      if (this.$refs.yt) {
        if (!this.$refs.yt.conditions) {
          this.$set(this.$refs.yt, 'conditions', {});
        }
        this.$set(this.$refs.yt.conditions, 'summaryDate', this.yesterdayStart());
        // 初次加载，使用包装后的 get（含前端分页）
        this.ensureClientPaging();
        this.$refs.yt.get(1);
      }
    }, 300);
  },
  mounted() {
    // 计算并监听高度，保证表格自适应
    this.$nextTick(() => {
      this.updateHeights();
      window.addEventListener('resize', this.updateHeights);
    });

    // 监听表格数据变化，缓存明细用于汇总
    this.$nextTick(() => {
      const yt = this.$refs.yt;
      if (!yt) return;
      // 若未设置日期，初始化为昨天，确保日期控件显示
      if (!yt.conditions) {
        this.$set(yt, 'conditions', {});
      }
      if (!yt.conditions.summaryDate) {
        const d = this.yesterdayStart();
        this.$set(yt.conditions, 'summaryDate', d);
        this.$set(this.query, 'summaryDate', d);
      } else if (!this.query.summaryDate) {
        this.$set(this.query, 'summaryDate', yt.conditions.summaryDate);
      }
      // 包装 get，保证分页事件也走前端分页
      this.ensureClientPaging();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateHeights);
  },
  computed: {
    summaryRows() {
      if (!Array.isArray(this.detailListCache) || this.detailListCache.length === 0) return [];
      const groups = new Map();
      const toDateStr = (ts) => {
        try {
          const d = new Date(ts);
          const y = d.getFullYear();
          const m = (d.getMonth() + 1).toString().padStart(2, '0');
          const day = d.getDate().toString().padStart(2, '0');
          return `${y}-${m}-${day}`;
        } catch (e) {
          return '';
        }
      };
      for (const row of this.detailListCache) {
        const dateStr = toDateStr(row.summaryDate);
        const equipmentName = row.equipmentName || '';
        const mouldNo = row.mouldNo || '';
        const key = `${dateStr}||${equipmentName}||${mouldNo}`;
        if (!groups.has(key)) {
          groups.set(key, {
            date: dateStr,
            equipmentName,
            mouldNo,
            peopleWorkHours: 0,
            deviceWorkHoursRaw: row.runDuration, // 保留原始值用于设备工时（任意一条）
            workHourTypes: new Set(),
            employeeNamesSet: new Set()
          });
        }
        const g = groups.get(key);
        const wh = Number(row.workHours) || 0;
        g.peopleWorkHours += wh;
        if (row.workHourType !== undefined && row.workHourType !== null && row.workHourType !== '') {
          g.workHourTypes.add(this.formatWorkHourType(row.workHourType));
        }
        if (row.employeeName) g.employeeNamesSet.add(row.employeeName);
      }
      const result = [];
      groups.forEach((g) => {
        // 设备工时：任取一条记录的值，按小时显示
        const deviceHours = this.hoursFromDuration(g.deviceWorkHoursRaw);
        result.push({
          date: g.date,
          equipmentName: g.equipmentName,
          mouldNo: g.mouldNo,
          peopleWorkHours: Number(g.peopleWorkHours.toFixed(2)),
          deviceWorkHours: Number(deviceHours.toFixed(2)),
          workHourTypeText: Array.from(g.workHourTypes).join('、'),
          employeeNames: Array.from(g.employeeNamesSet).join(',')
        });
      });
      return result;
    }
  },
  methods: {
    // 构建用于分页缓存的key（由查询条件+接口路径组成）
    buildCacheKey() {
      const yt = this.$refs && this.$refs.yt ? this.$refs.yt : null;
      if (!yt) return '';
      const url = yt.getUrl || '';
      const c = yt.conditions || {};
      const pick = {
        no: c.no || '',
        equipmentId: c.equipmentId || '',
        shiftId: c.shiftId || '',
        summaryDate: c.summaryDate || ''
      };
      try {
        return url + '|' + JSON.stringify(pick);
      } catch (e) {
        return url + '|' + String(pick);
      }
    },
    // 确保所有调用 yt.get 都会携带 afterGet（用于前端分页），并在有缓存时直接本地分页，无需请求
    ensureClientPaging() {
      const yt = this.$refs && this.$refs.yt ? this.$refs.yt : null;
      if (!yt || yt.__get_wrapped__) return;
      const originalGet = yt.get.bind(yt);
      yt.get = (pageNum, beforeReq, afterReq) => {
        const key = this.buildCacheKey();
        const hasCache = this.clientPageCacheKey === key && Array.isArray(this.clientPageFullRows) && this.clientPageFullRows.length >= 0;
        if (hasCache) {
          if (typeof pageNum === 'number') yt.pageNum = pageNum;
          const pageSize = yt.pageSize || 10;
          const total = this.clientPageFullRows.length;
          const start = Math.max(0, (Number(yt.pageNum || 1) - 1) * Number(pageSize));
          const end = start + Number(pageSize);
          const sliced = this.clientPageFullRows.slice(start, end);
          yt.total = total;
          yt.list = sliced;
          // 模拟异步返回结构
          return Promise.resolve({ data: { rows: sliced, total } });
        }
        const br = beforeReq || this.beforeGet;
        const ar = afterReq || ((res) => this.afterGet(res));
        return originalGet(pageNum, br, ar);
      };
      yt.__get_wrapped__ = true;
    },
    // afterGet: 将后端一次性返回的 rows 做本地分页切片，并缓存全量数据
    afterGet(result) {
      try {
        const yt = this.$refs && this.$refs.yt ? this.$refs.yt : null;
        const pageNum = yt ? yt.pageNum : 1;
        const pageSize = yt ? yt.pageSize : 10;
        let fullRows = [];
        if (result && result.data) {
          if (Array.isArray(result.data)) {
            fullRows = result.data;
          } else if (Array.isArray(result.data.rows)) {
            fullRows = result.data.rows;
          } else if (Array.isArray(result.rows)) {
            fullRows = result.rows;
          }
        }
        // 写入缓存key和全量数据
        this.clientPageCacheKey = this.buildCacheKey();
        this.clientPageFullRows = this.utils.copy(fullRows);
        // 汇总依赖全量
        this.detailListCache = this.utils.copy(fullRows);
        const total = fullRows.length;
        const start = Math.max(0, (Number(pageNum) - 1) * Number(pageSize));
        const end = start + Number(pageSize);
        const sliced = fullRows.slice(start, end);
        // 统一转换结构为 { data: { rows, total, ... } }
        const normalized = {
          ...result,
          data: {
            ...(result && typeof result.data === 'object' && !Array.isArray(result.data) ? result.data : {}),
            rows: sliced,
            total: total
          }
        };
        return normalized;
      } catch (e) {
        return result;
      }
    },
    onTabClick() {
      this.$nextTick(this.updateHeights);
    },
    updateHeights() {
      // 让明细表格容器高度撑满到视口底部
      try {
        const rect = this.$el && this.$el.getBoundingClientRect ? this.$el.getBoundingClientRect() : null;
        const viewportH = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        const paddingBottom = 16; // 页面底部留白
        if (rect && viewportH) {
          this.fixContainerHeight = Math.max(300, Math.floor(viewportH - rect.top - paddingBottom));
          // 汇总表高度与明细保持一致
          this.summaryTableHeight = this.fixContainerHeight - 140; // 预留tabs与内边距
        }
      } catch (e) {
        this.fixContainerHeight = 700;
        this.summaryTableHeight = 560;
      }
    },
    onSearch() {
      const yt = this.$refs && this.$refs.yt ? this.$refs.yt : null;
      if (!yt) return;
      if (!yt.conditions) {
        this.$set(yt, 'conditions', {});
      }
      // 将本地查询模型同步到表格条件
      this.$set(yt.conditions, 'no', this.query.no || '');
      this.$set(yt.conditions, 'equipmentId', this.query.equipmentId || '');
      this.$set(yt.conditions, 'shiftId', this.query.shiftId || '');
      this.$set(yt.conditions, 'summaryDate', this.query.summaryDate || '');
      // 查询条件变化，清空旧缓存
      this.clientPageCacheKey = '';
      this.clientPageFullRows = [];
      // 保证使用前端分页
      this.ensureClientPaging();
      yt.get(1);
    },
    beforeGet(params) {
      // 从表格条件提取，保证以 conditions 为准
      const yt = this.$refs && this.$refs.yt ? this.$refs.yt : null;
      if (yt && yt.conditions) {
        params['summaryDate'] = yt.conditions.summaryDate || '';
        params['no'] = yt.conditions.no || '';
        params['equipmentId'] = yt.conditions.equipmentId || '';
        params['shiftId'] = yt.conditions.shiftId || '';
      }
      return params;
    },
    clearConditions() {
      if (this.$refs && this.$refs.yt) {
        this.$set(this.$refs.yt, 'conditions', {});
        this.$set(this.$refs.yt.conditions, 'summaryDate', this.yesterdayStart());
      }
      // 重置本地查询
      this.query = {
        no: '',
        equipmentId: '',
        shiftId: '',
        summaryDate: this.yesterdayStart()
      };
      this.shiftOptions = [];
      this.shiftDisabled = true;
      // 条件变化，清空缓存
      this.clientPageCacheKey = '';
      this.clientPageFullRows = [];
      if (this.$refs && this.$refs.yt) {
        // 保证使用前端分页
        this.ensureClientPaging();
        this.$refs.yt.get(1);
      }
      this.$nextTick(this.updateHeights);
    },
    handleEquipmentChange(equipmentId) {
      // 同步本地 query 的设备变化已通过 v-model 完成
      // 根据设备获取班次
      if (!equipmentId) {
        this.shiftOptions = [];
        this.shiftDisabled = true;
        const yt = this.$refs && this.$refs.yt ? this.$refs.yt : null;
        if (yt) {
          if (!yt.conditions) {
            this.$set(yt, 'conditions', {});
          }
          this.$set(yt.conditions, 'shiftId', '');
        }
        this.$set(this.query, 'shiftId', '');
        return;
      }
      this.http
        .get('/web/setting/shift/getShiftByEquipmentId', {
          params: { equipmentId, pageNum: 1, pageSize: 1000 }
        })
        .then((res) => {
          this.shiftOptions = Array.isArray(res.data) ? res.data : [];
          this.shiftDisabled = false;
        });
    },
    formatDate(ts) {
      if (!ts) return '';
      try {
        const d = new Date(Number(ts));
        const y = d.getFullYear();
        const m = (d.getMonth() + 1).toString().padStart(2, '0');
        const day = d.getDate().toString().padStart(2, '0');
        return `${y}-${m}-${day}`;
      } catch (e) {
        return '';
      }
    },
    // 将毫秒转换为小时（小数）
    hoursFromDuration(value) {
      const num = Number(value);
      if (!isFinite(num) || num <= 0) return 0;
      // 后端为毫秒 → 小时
      return num / (1000 * 60 * 60);
    },
    formatHours(value) {
      const h = this.hoursFromDuration(value);
      // 显示为小数（两位），不带单位，由列标题体现"设备工时"
      return Number(h.toFixed(2));
    },
    formatWorkHourType(t) {
      const store = this.$store;
      const map = store && store.state && store.state.dictJsonAll && store.state.dictJsonAll['WORK_HOUR_TYPE'];
      const key = String(t);
      if (map && Object.prototype.hasOwnProperty.call(map, key)) {
        return this.$t(map[key]);
      }
      // 兼容可能的英文字段值
      const alias = {
        Normal: '0',
        Overtime: '1',
        Exception: '2'
      };
      const aliased = alias[key];
      if (aliased && map && Object.prototype.hasOwnProperty.call(map, aliased)) {
        return this.$t(map[aliased]);
      }
      // 兜底
      const fallback = { '0': '正常工时', '1': '加班工时', '2': '除外工时' };
      return fallback[key] || key;
    },
    yesterdayStart() {
      const now = new Date();
      const y = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      // y is today 00:00:00, subtract one day
      return y.getTime() - 24 * 60 * 60 * 1000;
    },
    exportDetailExcel() {
      this.exportLoading = true;
      const yt = this.$refs && this.$refs.yt ? this.$refs.yt : null;
      const params = yt && yt.conditions ? { ...yt.conditions } : {};
      this.http
        .get('/web/report/page/work_hour_report?pageNum=1&pageSize=999999', { params })
        .then((res) => {
          const rows = res && res.data && (res.data.rows || res.data) ? (Array.isArray(res.data.rows) ? res.data.rows : (Array.isArray(res.data) ? res.data : [])) : [];
          const headers = [
            this.$t('jihuadanhao'),
            this.$t('shebeimingcheng'),
            this.$t('mujubianhao'),
            this.$t('gonghao'),
            this.$t('xingming'),
            this.$t('baogongbanci'),
            this.$t('riqi'),
            this.$t('renyuangongshi'),
            this.$t('shebeigongshi'),
            this.$t('gongshileixing')
          ];
          const tableData = [headers];
          if (Array.isArray(rows) && rows.length > 0) {
            for (let i = 0; i < rows.length; i++) {
              const item = rows[i] || {};
              const rowArr = [];
              rowArr[headers.indexOf(this.$t('jihuadanhao'))] = item.no || '';
              rowArr[headers.indexOf(this.$t('shebeimingcheng'))] = item.equipmentName || '';
              rowArr[headers.indexOf(this.$t('mujubianhao'))] = item.mouldNo || '';
              rowArr[headers.indexOf(this.$t('gonghao'))] = item.jobNo || '';
              rowArr[headers.indexOf(this.$t('xingming'))] = item.employeeName || '';
              rowArr[headers.indexOf(this.$t('baogongbanci'))] = item.shiftName || '';
              rowArr[headers.indexOf(this.$t('riqi'))] = this.formatDate(item.summaryDate);
              rowArr[headers.indexOf(this.$t('renyuangongshi'))] = item.workHours != null ? Number(item.workHours).toFixed(2) : '';
              rowArr[headers.indexOf(this.$t('shebeigongshi'))] = this.formatHours(item.runDuration);
              rowArr[headers.indexOf(this.$t('gongshileixing'))] = this.formatWorkHourType(item.workHourType);
              tableData.push(rowArr);
            }
          }
          const worksheet = XLSX.utils.aoa_to_sheet(tableData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          const fileName = `工时明细_${this.dayjs ? this.dayjs().format('YYYY-MM-DD_HH-mm-ss') : new Date().toISOString().slice(0,19).replace('T','_').replace(/:/g,'-')}.xlsx`;
          XLSX.writeFile(workbook, fileName);
        })
        .finally(() => {
          this.exportLoading = false;
        });
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  padding-left: 24px;
  padding-right: 24px;
  overflow: auto;
  min-width: 500px;
}

/* 让搜索条件在窄屏自动换行并保持紧凑 */
.demo-form-inline {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}
.demo-form-inline ::v-deep .el-form-item {
  margin-right: 12px;
}
</style>
